import axios from "axios";

const getApiUrl = () => "https://api.kcmc.im/";

export const api = axios.create({
  baseURL: getApiUrl(),
});

api.interceptors.request.use((config) => {
  const accessToken = localStorage.getItem("token");
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }
  return config;
});

// 로그인
export const login = (data) => api.post(`/api/auth/login`, data);

// 로그인 정보
export const getLoginInfo = () => api.get(`/api/auth/me`);

// 회사 정보 가져오기
export const getCompanyInfo = (locale) =>
  api.get(`/api/company?locale=${locale}`);

// 회사 정보 수정
export const updateCompanyInfo = (data) => api.patch(`/api/company`, data);

// 회사 성과 조회
export const getCompanyPerformance = () => api.get("/api/performance");

// 회사 성과 수정
export const updateCompanyPerformance = (data) =>
  api.patch(`/api/performance`, data);

// 개인정보 처리 방침 조회
export const getPrivacyPolicy = (locale) =>
  api.get(`/api/privacy?locale=${locale}`);

// 개인정보 처리 방침 수정
export const updatePrivacyPolicy = (data) => api.patch(`/api/privacy`, data);

// 이메일 수집 거부 조회
export const getEmailCollectionRefusal = (locale) =>
  api.get(`/api/email-policy?locale=${locale}`);

// 이메일 수집 거부 수정
export const updateEmailCollectionRefusal = (data) =>
  api.patch(`/api/email-policy`, data);

// 소식 조회
export const getNews = ({ page, limit, sort, locale, search }) => {
  const params = {
    page,
    limit,
    ...(sort && { sort }),
    ...(locale && { locale }),
    ...(search && { search }),
  };

  return api.get(`/api/news`, { params });
};

// 뉴스 하나 조회
export const getNewsOne = (id) => api.get(`/api/news/${id}`);

// 뉴스 생성
export const createNews = (data) => api.post(`/api/news`, data);

// 뉴스 수정
export const updateNews = (id, data) => api.patch(`/api/news/${id}`, data);

// 뉴스 삭제
export const deleteNews = (id) => api.delete(`/api/news/${id}`);

// 이미지 업로드
export const postUpload = (formData) =>
  api.post("/api/upload", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

// 품목 리스트 조회
export const getProducts = ({
  page,
  limit,
  sort,
  locale,
  category,
  search,
}) => {
  const params = {
    page,
    limit,
    ...(sort && { sort }),
    ...(locale && { locale }),
    ...(category && { category }),
    ...(search && { search }),
  };

  return api.get(`/api/items`, { params });
};

// 품목 하나 조회
export const getProductOne = (id) => api.get(`/api/items/group/${id}`);

// 품목 생성
export const createProduct = (data) => api.post(`/api/items`, data);

// 품목 수정
export const updateProduct = (id, data) =>
  api.patch(`/api/items/group/${id}`, data);

// 품목 삭제
export const deleteProduct = (id) => api.delete(`/api/items/group/${id}`);

// contact 리스트 조회
export const getContacts = ({
  page,
  limit,
  sort,
  locale,
  hasDocument,
  search,
}) => {
  const params = {
    page,
    limit,
    ...(sort && { sort }),
    ...(locale && { locale }),
    ...(hasDocument && { hasDocument }),
    ...(search && { search }),
  };

  return api.get(`/api/contact`, { params });
};

// contact 하나 조회
export const getContactOne = (id) => api.get(`/api/contact/${id}`);

// contact 수정
export const updateContact = (id, data) =>
  api.patch(`/api/contact/${id}`, data);

// contact 삭제
export const deleteContact = (id) => api.delete(`/api/contact/${id}`);
